export const isImageFileExtension = (src: string): boolean => {
    return /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(src);
};
